import React from 'react';
import { KeyRound } from 'lucide-react';

/**
 * The one explanation of app passwords, shown wherever one is asked for.
 *
 * The line that matters is the last one: the same Gmail/Zoho app password
 * sends (SMTP) and reads (IMAP), so a builder who saved one for sending does
 * not need a second one to connect that inbox for lead alerts.
 */
export default function AppPasswordHelp() {
  return (
    <div className="flex gap-3 rounded-lg border border-gray-200 bg-[#f7fbfc] px-4 py-3 text-xs text-gray-700">
      <KeyRound className="mt-0.5 h-4 w-4 shrink-0 text-[#1E4A53]" />
      <div className="space-y-1">
        <p className="font-semibold text-gray-900">
          Use a Google app password, not your normal one
        </p>
        <ol className="list-decimal space-y-0.5 pl-4">
          <li>Turn on 2-Step Verification for the Google account.</li>
          <li>
            Open{' '}
            <a
              href="https://myaccount.google.com/apppasswords"
              target="_blank"
              rel="noreferrer"
              className="text-[#1E4A53] underline">
              myaccount.google.com/apppasswords
            </a>
            .
          </li>
          <li>Create one named &quot;Housingram&quot; and paste the 16-character code here.</li>
        </ol>
        <p className="text-gray-500">
          The same app password works for sending and for reading lead alerts from this inbox.
        </p>
      </div>
    </div>
  );
}
